import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

class MCT extends BaseCalculator {

    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_TD_B] : {
            '正常' : 0,
            '微凸' : 1,
            '凸肚' : 2,
        },
        [C.B_TTT_HT] : {
            '瘦臀' : -1,
            '正常' : 0,
            '丰臀' : 1,
        },
        [C.B_ZTT_H] : {
            '翘臀' : -1,
            '正常' : 0,
            '坠臀' : 1,
        }
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
        [C.SOMATOTYPE_A] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },
        [C.SOMATOTYPE_B] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },
        [C.SOMATOTYPE_C] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },
        [C.SOMATOTYPE_D] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },
        [C.SOMATOTYPE_Y] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37.5 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },
        [C.SOMATOTYPE_T] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_KC_TL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KC_TL]) + parseFloat(base[C.C_KC_TL]) + parseFloat(plus[C.C_KC_TL])
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                },
                [C.C_ZLC_FBR] : function (net, base, plus) {
                    return 37 + parseFloat(base[C.C_ZLC_FBR]) + parseFloat(plus[C.C_ZLC_FBR])
                },
                [C.C_HD_T] : function (net, base, plus) {
                    return parseFloat(net[C.N_DTW_LL]) + parseFloat(base[C.C_HD_T]) + parseFloat(plus[C.C_HD_T])
                },
                [C.C_XW_KL] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL])+ parseFloat(base[C.C_XW_KL]) + parseFloat(plus[C.C_XW_KL])
                },
                [C.C_JK_F] : function (net, base, plus) {
                    return parseFloat(net[C.N_XTDW_CL]) + parseFloat(base[C.C_JK_F]) + parseFloat(plus[C.C_JK_F])
                },
            }
        },

    }


    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比
        this.ratio_xy = (this.net_size[C.N_ZYW_MWL] / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - parseFloat(this.net_size[C.N_TW_HL])

    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] : .5,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 1,
                    [C.C_YW_WL] :  1.5,
                    [C.C_TW_HL] :  1.5,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  1.5,
                    [C.C_JK_F] :  1.5,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  .5,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 1,
                    [C.C_YW_WL] :  1.5,
                    [C.C_TW_HL] :  1.5,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  1.5,
                    [C.C_JK_F] :  1.5,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  .5,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 1,
                    [C.C_YW_WL] :  1.5,
                    [C.C_TW_HL] :  1.5,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  1.5,
                    [C.C_JK_F] :  1.5,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  .5,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 1,
                    [C.C_YW_WL] :  1.5,
                    [C.C_TW_HL] :  1.5,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  2,
                    [C.C_JK_F] :  2,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  -.5,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 2,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  1.5,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  1.5,
                    [C.C_JK_F] :  1.5,
                }
            },
            [C.SOMATOTYPE_T] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  -1,
                    [C.C_ZLC_FBR] :  -.2,
                    [C.C_HD_T] :  -1,
                    [C.C_XW_KL] :  -1,
                    [C.C_JK_F] :  -1,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : 0,
                    [C.C_YW_WL] :  .5,
                    [C.C_TW_HL] :  0,
                    [C.C_ZLC_FBR] :  0,
                    [C.C_HD_T] :  0,
                    [C.C_XW_KL] :  0,
                    [C.C_JK_F] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : 1,
                    [C.C_YW_WL] :  1.5,
                    [C.C_TW_HL] :  2,
                    [C.C_ZLC_FBR] :  0.3,
                    [C.C_HD_T] :  2,
                    [C.C_XW_KL] :  1.5,
                    [C.C_JK_F] :  1.5,
                }
            },
        }

        return data[somatotype][preference]
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 1.5 + 5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 4.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 4.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 1.5 + 4.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 - 0.5,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 1.5 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -5,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  4,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 1.5 + 4) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  5.5,
                    [C.C_JK_F] :  -3,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  6,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 6) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 6,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  6,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 6) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 6,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25,
                    [C.C_TW_HL] :  6,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 1.5 + 6) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 6,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                }
            },
            [C.SOMATOTYPE_T] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 + .5,
                    [C.C_TW_HL] :  3.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) - 1 + 3.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 + .5,
                    [C.C_TW_HL] :  3.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 0 + 3.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_KC_TL] : -6,
                    [C.C_YW_WL] :  ((parseFloat(this.net_size[C.N_LW_CL]) * 2) - parseFloat(this.net_size[C.N_KYW_TWL])) * 0.25 + .5,
                    [C.C_TW_HL] :  3.5,
                    [C.C_ZLC_FBR] : ((parseFloat(this.net_size[C.N_TW_HL]) + 2 + 3.5) * 0.3 + parseFloat(this.net_size[C.N_TDC_CL]) * 0.5) / 2,
                    [C.C_HD_T] :  (parseFloat(this.net_size[C.N_DTW_LL]) - parseFloat(this.net_size[C.N_TW_HL])/2) * 0.4 + 4.5,
                    [C.C_XW_KL] :  6,
                    [C.C_JK_F] :  -2.5,
                }
            },

        }

        return data[somatotype][preference]
    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        let somatotype = this.custom_somatotype || this.default_somatotype
        let base_size = this.base(somatotype , this.preference)
        let plus_size = this.plus(somatotype, this.preference)
        let formulas = this.complete_size[somatotype][this.preference];

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key].apply(this, [this.net_size, base_size, plus_size]) * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }

        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default MCT
